import React                       from 'react';
import { countersinks as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent           from './CheckboxComponent';

const PlatedSlots = (props) => {
  const name = 'countersinks';
  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label="Countersink"
      tooltip={props.tooltip}
      checked={props.parameters[name] === '1'}
      onChange={e => props.onChangeParameter(name, e.target.checked ? '1' : '0')} />
  );
};

PlatedSlots.defaultProps = {
  tooltip,
};

export default PlatedSlots;
